import { Box } from '@mui/material';

interface BadgeProps {
  value: string,
  type: string
}

const getColors = (type: string) => {
  switch (type) {
    case 'success':
      return { bg: '#31C07D26', color: '#31C07D' };
    case 'error':
      return { bg: '#F53C2D26', color: '#F53C2D' };
    case 'warning':
      return { bg: '#FF950026', color: '#FF9500' };
    default:
      return { bg: '#e0e0e0', color: '#333' };
  }
};

export default function ScoreBadge({value, type}: BadgeProps) {
  const { bg, color } = getColors(type);

  return (
    <Box
      sx={{
        px: '16px',
        py: '4px',
        backgroundColor: bg,
        color: color,
        fontWeight: 700,
        borderRadius: '12px',
        fontSize: '16px',
        display: 'inline-block',
        minWidth: '48px',
        textAlign: 'center',
      }}
    >
      {value}
    </Box>
  );
}
